"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createStore = _interopRequireDefault(require("../../../create-store"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TrebleCoreStore = (0, _createStore["default"])([{
  action: 'updateTrebleCoreData',
  state: {
    trebleCoreData: {
      subscribeAPI: null,
      moduleData: null
    }
  }
}, {
  action: 'runTrebleCoreMiddleware',
  state: {
    trebleCoreMiddleware: true
  }
}]);
var _default = TrebleCoreStore;
exports["default"] = _default;
module.exports = exports.default;